<template>
  <div class="reviews-wrap">
    <div class="d-none d-md-block" id="large-screen">
      <carousel
        :autoplay="true"
        :autoplayHoverPause="true"
        :autoplayTimeout="5000"
        :paginationSize="10"
        :perPage="1"
        paginationActiveColor="#ff0c47"
        paginationColor="#ffa9be"
      >
        <slide>
          <div class="review">
            <p class="review-text">
              Shani is a fantastic coach. Her intuition is matched onlyby
              business prowess. She helped me organize and become more efficient
              in the things I do leading to the growth of my business. She is a
              pleasure to work with, a very detailed and strategic thinker, and
              pushed me to higher levels of personal and professional growth. I
              look forward to keep working with her.
            </p>
            <div class="review-by">
              <p>J.R. Rothstein</p>
              <p>Esq. Legal Counsel at Spotify</p>
              <p>August 2, 2020</p>
            </div>
          </div>
          <div class="review">
            <p class="review-text">
              Working with Shani has transformed my life. We worked on personal
              development. From day one, we got results! Throughout our coaching
              sessions, I was amazed at the new awareness I experienced and how
              this new awareness shifted my mindset. Going from a scarcity
              mindset to an abundance mindset. Today, I have clarity on my life
              purpose, and tools to utilize moving forward. I highly recommend
              Shani to anyone looking to take there life to the next level.
              Thanks Shani.
            </p>
            <div class="review-by">
              <p>Michael Davis</p>
              <p>Financial Analyst at First Advantage</p>
              <p>June 12, 2020</p>
            </div>
          </div>
        </slide>
        <slide>
          <div class="review">
            <p class="review-text">
              Shani was a great pleasure to work with. She really helped me to
              change my perspective and in turn my business into a successful
              one. Her shinning attitude mixed with a "no nonsense, let's get
              down to business way" really helped me break through the parts of
              myself that were holding me back from running a successful
              business. I would recommend her to anyone who needs personal or
              business coaching. Thank you Shani!
            </p>
            <div class="review-by">
              <p>Eleonora Engelbrecht</p>
              <p>August 21, 2019</p>
            </div>
          </div>
          <div class="review">
            <p class="review-text">
              Usually I do not share my challenges with people because I feel
              I’m strong and I can deal with it but somehow, I was able to share
              with my coach Shani. From the moment I shared these with Shani, I
              knew I made the right decision. Shani demonstrated a lot of
              professionalism, empathy, and commitment. Within few weeks, I was
              able to bounce back. I became a better professional, a better
              husband and dad and above all, I was able to be at peace with
              myself. Thank you so much Shani for not giving up on me and for
              making me a better man today.
            </p>
            <div class="review-by">
              <p>Brorhie Muoboghare</p>
              <p>August 3, 2019</p>
            </div>
          </div>
        </slide>
        <slide>
          <div class="review">
            <p class="review-text">
              Shani possesses a true passion and commitment to every team and
              project. She is a highly-skilled Scrum Master/Iteration Manager
              with deep skills in Agile Team Facilitation. She can wear many
              hats and has the ability to identify the problem, and quickly
              reach to a resolution. She has done a superb job in supporting
              multi million dollar project and single handed come to resolution
              maintaining a client relationship and save the project. She is
              dedicated and result-driven individual.
            </p>
            <div class="review-by">
              <p>Matt Khodadad</p>
              <p>March 17, 2018</p>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <div class="d-block d-md-none" id="small-screen">
      <carousel
        :autoplay="true"
        :autoplayHoverPause="true"
        :autoplayTimeout="5000"
        :perPage="1"
        paginationActiveColor="#ff0c47"
        paginationColor="#ffa9be"
      >
        <slide>
          <div class="review">
            <p class="review-text">
              Shani is a fantastic coach. Her intuition is matched onlyby
              business prowess. She helped me organize and become more efficient
              in the things I do leading to the growth of my business. She is a
              pleasure to work with, a very detailed and strategic thinker, and
              pushed me to higher levels of personal and professional growth. I
              look forward to keep working with her.
            </p>
            <div class="review-by">
              <p>J.R. Rothstein</p>
              <p>Esq. Legal Counsel at Spotify</p>
              <p>August 2, 2020</p>
            </div>
          </div>
        </slide>
        <slide>
          <div class="review">
            <p class="review-text">
              Working with Shani has transformed my life. We worked on personal
              development. From day one, we got results! Throughout our coaching
              sessions, I was amazed at the new awareness I experienced and how
              this new awareness shifted my mindset. Going from a scarcity
              mindset to an abundance mindset. Today, I have clarity on my life
              purpose, and tools to utilize moving forward. I highly recommend
              Shani to anyone looking to take there life to the next level.
              Thanks Shani.
            </p>
            <div class="review-by">
              <p>Michael Davis</p>
              <p>Financial Analyst at First Advantage</p>
              <p>June 12, 2020</p>
            </div>
          </div>
        </slide>
        <slide>
          <div class="review">
            <p class="review-text">
              Shani was a great pleasure to work with. She really helped me to
              change my perspective and in turn my business into a successful
              one. Her shinning attitude mixed with a "no nonsense, let's get
              down to business way" really helped me break through the parts of
              myself that were holding me back from running a successful
              business. I would recommend her to anyone who needs personal or
              business coaching. Thank you Shani!
            </p>
            <div class="review-by">
              <p>Eleonora Engelbrecht</p>
              <p>August 21, 2019</p>
            </div>
          </div>
        </slide>
        <slide>
          <div class="review">
            <p class="review-text">
              Usually I do not share my challenges with people because I feel
              I’m strong and I can deal with it but somehow, I was able to share
              with my coach Shani. From the moment I shared these with Shani, I
              knew I made the right decision. Shani demonstrated a lot of
              professionalism, empathy, and commitment. Within few weeks, I was
              able to bounce back. I became a better professional, a better
              husband and dad and above all, I was able to be at peace with
              myself. Thank you so much Shani for not giving up on me and for
              making me a better man today.
            </p>
            <div class="review-by">
              <p>Brorhie Muoboghare</p>
              <p>August 3, 2019</p>
            </div>
          </div>
        </slide>
        <slide>
          <div class="review">
            <p class="review-text">
              Shani possesses a true passion and commitment to every team and
              project. She is a highly-skilled Scrum Master/Iteration Manager
              with deep skills in Agile Team Facilitation. She can wear many
              hats and has the ability to identify the problem, and quickly
              reach to a resolution. She has done a superb job in supporting
              multi million dollar project and single handed come to resolution
              maintaining a client relationship and save the project. She is
              dedicated and result-driven individual.
            </p>
            <div class="review-by">
              <p>Matt Khodadad</p>
              <p>March 17, 2018</p>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <a href="https://www.linkedin.com/in/shani-tsadik-0a959888/" target="_blank"
      ><button class="button btn-outlined review-btn">See More Reviews</button>
    </a>
  </div>
</template>

<script>
export default {
  name: "LinkedinReviewsCarousel",
};
</script>

<style scoped lang="scss">
.reviews-wrap {
  margin: 80px 0 40px 0;

  .review {
    width: 90%;
    border: 1px solid #ccc;
    padding: 20px;
    text-align: left;
    background-color: #ffe7ea;
    font-style: italic;

    @media screen and (min-width: 768px) {
      width: 45%;
    }

    .review-text {
      &::before {
        content: "\201c";
      }

      &::after {
        content: "\201D";
      }
    }

    .review-by {
      text-align: center;
      margin-top: 20px;
      font-style: normal;

      p {
        margin-bottom: 2px;
      }

      p:first-child {
        font-weight: 600;
      }

      p:nth-child(2),
      p:nth-child(3) {
        font-size: 12px;
      }
    }
  }

  .review-btn {
    margin-top: 20px;
  }
}

.VueCarousel-slide {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
}

// #small-screen .VueCarousel-slide::after {
//   content: "";
//   background: transparent;
//   width: 100%;
//   height: 100%;
//   min-height: 1px;
//   position: absolute;
//   top: 0;
// }

@media screen and (min-width: 768px) {
  .reviews-wrap .review-btn {
    float: left;
  }
}
</style>
